import { apiFetch, withQuery } from '@/app/apiClient';

import {
  DASHBOARD_ENDPOINTS,
  type DashboardApi,
  type DashboardKpis,
  type DriftFlag,
  type EvidenceApproval,
  type RecentRun,
  type RecentRunsQuery,
  type SourceSyncHealth,
  type ValidationIssue,
} from './api';

/**
 * Real HTTP client for the Overview screen. Mirrors the `createMockDashboardApi`
 * contract so a screen can swap from in-memory fixtures to the Axum-backed
 * `sentinel-api` by changing a single `DEFAULT_API = …` line.
 */
export function createFetchDashboardApi(): DashboardApi {
  return {
    getRecentRuns: async (query?: RecentRunsQuery) =>
      apiFetch<RecentRun[]>(
        withQuery(DASHBOARD_ENDPOINTS.recentRuns, { window: query?.window }),
      ),
    getDriftFlags: async () => apiFetch<DriftFlag[]>(DASHBOARD_ENDPOINTS.driftFlags),
    getPendingEvidenceApprovals: async () =>
      apiFetch<EvidenceApproval[]>(DASHBOARD_ENDPOINTS.evidenceApprovals),
    getSourceSyncHealth: async () =>
      apiFetch<SourceSyncHealth[]>(DASHBOARD_ENDPOINTS.sourceSyncHealth),
    getTopValidationIssues: async () =>
      apiFetch<ValidationIssue[]>(DASHBOARD_ENDPOINTS.topValidationIssues),
    getKpis: async () => apiFetch<DashboardKpis>(DASHBOARD_ENDPOINTS.kpis),
  };
}
